import { Button, Modal, Trans } from '@/components'

interface InsufficientRechargeCreditsModalProps {
  // pre-formatted credit amounts, e.g. "10" / "5.000"
  requiredCredits: string
  availableCredits: string
  onClose: () => void
  onRecharge?: () => void
}

export function InsufficientRechargeCreditsModal({
  requiredCredits,
  availableCredits,
  onClose,
  onRecharge,
}: InsufficientRechargeCreditsModalProps) {
  return (
    <Modal open onClose={onClose}>
      <Modal.Header>
        <Trans i18nKey="create.insufficientRechargeCredits.title">
          Insufficient Recharged Credits
        </Trans>
      </Modal.Header>
      <Modal.Body>
        <p>
          <Trans
            i18nKey="create.insufficientRechargeCredits.description"
            values={{ required: requiredCredits, available: availableCredits }}
            components={{ hl: <span className="text-highlight" /> }}
          />
        </p>
        <p className="mt-6">
          {onRecharge ? (
            <Trans i18nKey="create.insufficientRechargeCredits.hint">
              Please recharge your account to continue.
            </Trans>
          ) : (
            <Trans i18nKey="create.insufficientRechargeCredits.ownerOnlyHint">
              Only the team owner can recharge this account. Please contact your team owner to add
              Recharged Credits.
            </Trans>
          )}
        </p>
        <p className="mt-6">
          <Trans i18nKey="create.insufficientRechargeCredits.note">
            Only Recharged Credits can be used to purchase subscriptions. Other credit types are
            valid for pay-as-you-go instances only.
          </Trans>
        </p>
      </Modal.Body>
      <Modal.Footer>
        {onRecharge ? (
          <>
            <Button type="outline" className="min-w-[88px]" onClick={onClose}>
              <Trans i18nKey="common.confirmModalCancel">Cancel</Trans>
            </Button>
            <Button type="secondary" className="min-w-[88px]" onClick={onRecharge}>
              <Trans i18nKey="create.insufficientRechargeCredits.rechargeNowBtn">
                Recharge Now
              </Trans>
            </Button>
          </>
        ) : (
          <Button type="secondary" className="min-w-[88px]" onClick={onClose}>
            <Trans i18nKey="common.gotIt">Got it</Trans>
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}
